import { createContext } from "react";
import { theme } from "../theme/theme";

export const ThemeColorContext = createContext(theme);
